<template>
  <v-sheet
    class="mt-5"
    color="inherit"
    elevation="2"
    max-width="100%"
  >
    <v-slide-group
      v-model="model"
      class=""
      show-arrows
    >
      <v-slide-item
        v-for="(item, index) in items"
        :key="index"
      >
        <v-card
          class="d-flex ma-4 pa-2 align-center"
          elevation="1"
          height="136"
          width="176"
          @click="click(index, item)"
        >
          <v-img max-width="160" max-height="120" :src="item.preview || item.src" :alt="item.alt" contain></v-img>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
  export default {
    name: "ImgCarousel",
    props: {
      items: {
        type: Array,
        required: true
      },
    },
    data () {
      return {
        model: null
      }
    },
    methods: {
      click (index, item) {
        this.$emit('click', { index, item });
      }
    }
  }
</script>

<style scoped>
  .v-sheet {
    background-color: inherit;
  }
</style>
